import * as ActionTypes from './EnumTypes/ActionEnumTypes';
import * as MapActionModel from './Models/MapActionModel';
import * as L from 'leaflet';
function setMapCenter(center: MapActionModel.MapCenter, zoom: number = null): MapActionModel.SetMapCenter {
    return {
        type: ActionTypes.MAP.SET_CENTER,
        payload: {
            center,
            zoom
        }
    };
}

function setMapZoom(zoom: number): MapActionModel.SetZoom {
    return {
        type: ActionTypes.MAP.SET_ZOOM,
        payload: {
            zoom
        }
    };
}
function manageZoom(type: 'add' | 'substract'): MapActionModel.ManageZoom {
    return {
        type: ActionTypes.MAP.MANAGE_ZOOM,
        payload: {
            type
        }
    };
}
function smallMapsetMapCenter(center: MapActionModel.MapCenter): MapActionModel.SmallMapSetMapCenter {
    return {
        type: ActionTypes.MAP.SMALL_MAP_SET_CENTER,
        payload: {
            center
        }
    };
}

function smallMapsetMapZoom(zoom: number): MapActionModel.SmallMapSetZoom {
    return {
        type: ActionTypes.MAP.SMALL_MAP_SET_ZOOM,
        payload: {
            zoom
        }
    };
}
function smallMapmanageZoom(type: 'add' | 'substract'): MapActionModel.SmallMapManageZoom {
    return {
        type: ActionTypes.MAP.SMALL_MAP_MANAGE_ZOOM,
        payload: {
            type
        }
    };
}
function setSmallMapRef(map: any): MapActionModel.SetSmallMapRef {
    return {
        type: ActionTypes.MAP.SET_SMALL_MAP_REF,
        payload: {
            map
        }
    };
}
function setMapRef(map: any): MapActionModel.SetMapRef {
    return {
        type: ActionTypes.MAP.SET_MAP_REF,
        payload: {
            map
        }
    };
}
function setSmallMapLatestBounds(bounds: L.LatLngBounds): MapActionModel.SetSmallMapLatestBounds {
    return {
        type: ActionTypes.MAP.SET_SMALL_MAP_LATEST_BOUNDS,
        payload: {
            bounds
        }
    };
}
function setMapLatestBounds(bounds: L.LatLngBounds): MapActionModel.SetMapLatestBounds {
    return {
        type: ActionTypes.MAP.SET_MAP_LATEST_BOUNDS,
        payload: {
            bounds
        }
    };
}
export { setMapCenter, setMapZoom, manageZoom, smallMapsetMapCenter, smallMapsetMapZoom, smallMapmanageZoom, setMapLatestBounds, setSmallMapLatestBounds, setSmallMapRef, setMapRef };



// WEBPACK FOOTER //
// ./src/Redux/Actions/MapActions.ts